import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';

import { AlertMessageService, SigepeMainLayoutModule } from '@sigepe/sigepe-template';
import { SegurancaService } from '@sigepe/ngx-sigepe-seguranca';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs';
import pkg from '../../package.json';

@Component({
	selector: 'sgp-root',
	templateUrl: './app.component.html',
	standalone: true,
	imports: [SigepeMainLayoutModule, RouterOutlet]
})
export class AppComponent implements OnInit {
	showNotifications = true;
	public version = pkg.version;

	private readonly activatedRoute = inject(ActivatedRoute);
	private readonly alertMessageService = inject(AlertMessageService);
	private readonly router = inject(Router);
	private readonly segurancaService = inject(SegurancaService);
	private readonly titleService = inject(Title);

	ngOnInit() {
		this.configurarTituloPagina();
		this.limparMensagens();
		this.titleService.setTitle('');
	}

	logout() {
		this.segurancaService.logout();
	}

	private configurarTituloPagina() {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
			const rt = this.getChild(this.activatedRoute);
			rt.data.subscribe((data: { title: string }) => {
				this.titleService.setTitle(data.title + ' - Avaliação de Desempenho v.' + this.version);
			});
		});
	}

	private getChild(activatedRoute: ActivatedRoute): any {
		if (activatedRoute.firstChild) {
			return this.getChild(activatedRoute.firstChild);
		} else {
			return activatedRoute;
		}
	}

	private limparMensagens() {
		this.alertMessageService.dismissAll();
	}
}
